export const getStorageNotification = (key: string): number => {
  const value = localStorage.getItem(`notification_${key}`);
  return value ? parseInt(value) : 1; // Default to 1 (show)
};

export const saveStorageNotification = (key: string, value: number): void => {
  localStorage.setItem(`notification_${key}`, value.toString());
};